package com.tregz.polyglot.ai

import com.tregz.polyglot.di.Secrets
import com.tregz.polyglot.di.secrets
import dev.shreyaspatil.ai.client.generativeai.GenerativeModel
import kotlinx.coroutines.CancellationException

object Gemini {
    private const val MODEL = "gemini-flash-lite-latest"

    private var model: GenerativeModel? = null

    /** True when an API key is configured (a missing key is otherwise only visible as null). */
    val isConfigured: Boolean
        get() = try {
            secrets.getEnv(Secrets.GEMINI_API_KEY).isNotBlank()
        } catch (ex: CancellationException) {
            throw ex
        } catch (_: Throwable) {
            false
        }

    /** Only a successfully created model is cached, so a late-arriving key is picked up. */
    val flash: GenerativeModel?
        get() {
            model?.let { return it }
            return try {
                val secret = secrets.getEnv(Secrets.GEMINI_API_KEY)
                if (secret.isNotBlank()) GenerativeModel(MODEL, secret).also { model = it } else null
            } catch (ex: CancellationException) {
                throw ex
            } catch (ex: Throwable) {
                println("[Polyglot] Gemini model creation failed: ${ex.message}")
                null
            }
        }
}
